import { useEffect, useState } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { RadioButtonItemProps } from './RadioButtonItem.types';

const usePresenter = (props: RadioButtonItemProps) => {
  const {
    className,
    checked,
    defaultChecked,
    value,
    disabled = false,
    invalid = false,
    required = false,
    labelAlignment = 'Left',
    children,
    showRightButton = false,
    onRightButtonClick,
    rightButtonIcon,
    onChange,
    ...otherProps
  } = props;

  const [isSelected, setIsSelected] = useState(checked ?? defaultChecked ?? false);

  useEffect(() => {
    setIsSelected(!!checked);
  }, [checked]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsSelected(true);
    onChange?.(event);
  };

  const variantProps = useBuildVariantProps(
    'radio-button-item',
    {
      styles: isSelected ? 'selected' : 'unselected',
    },
    {
      disabled,
      invalid,
    },
  );

  return {
    handleChange,
    variantProps,
    isSelected,
    checked,
    defaultChecked,
    value,
    disabled,
    invalid,
    required,
    labelAlignment,
    children,
    showRightButton,
    onRightButtonClick,
    otherProps,
    rightButtonIcon,
  };
};

export default usePresenter;